// extracted by mini-css-extract-plugin
export default {"saleBannerText":"iU42sq","saleDash":"iBCouc","divider":"D1GV_V"};